import React, { useState, useEffect } from 'react';
import './portfolio.css';
import Image1 from '../../pages/projects/assets/power/2025-0821-power-office-lounge-kitchen.jpg';
import Image2 from '../../pages/projects/assets/group-management/2025-0821-group-management-kitchen.jpg';
import Image3 from '../../pages/projects/assets/nfm-lending/2025-0821-nfm-lending-meeting-room.jpg';
import Image4 from '../../pages/projects/assets/northwoods/IMG_2393.jpg';
import Image5 from './assets/2024-0607-portfolio-slide-1.jpg';
import Image6 from '../../pages/projects/assets/power/2025-0821-power-office-lounge-island.jpg';
import Image7 from '../../pages/projects/assets/sequoia/2025-0821-sequoia-main-lobby.jpg';
import Image8 from '../../pages/projects/assets/employers-health/2025-0821-employers-health-hall.jpg';

const Portfolio = ({ images = [Image1, Image2, Image3, Image4, Image5, Image6, Image7, Image8] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  useEffect(() => {
    if (images.length === 0 || !isPlaying) return;

    const interval = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % images.length);
    }, 10000); // Change image every 10 seconds

    return () => clearInterval(interval);
  }, [images.length, isPlaying]);

  const handlePrev = () => {
    pauseCarousel();
    setCurrentIndex(currentIndex === 0 ? images.length - 1 : currentIndex - 1);
  };

  const handleNext = () => {
    pauseCarousel();
    setCurrentIndex((currentIndex + 1) % images.length);
  };

  const pauseCarousel = () => {
    setIsPlaying(false);
    clearTimeout(window.resumeTimer); // clear any existing timer
    window.resumeTimer = setTimeout(() => setIsPlaying(true), 15000); // resume after 15s
  };

  const togglePlayPause = () => {
    setIsPlaying(!isPlaying);
  };

  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null); // Otherwise, the swipe is fired even with usual touch events
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX);

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      pauseCarousel();
      handleNext();
    } else if (isRightSwipe) {
      pauseCarousel();
      handlePrev();
    }

    setTouchStart(null);
    setTouchEnd(null);
  };




  if (images.length === 0) {
    return <div>No images available</div>;
  }

  return (
    <div className="portfolio-container">
      <div
        className="portfolio-wrapper"
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        {images.map((image, index) => {
          let className = 'portfolio-slide';
          if (index === currentIndex) {
            className += ' active';
          } else if (index === (currentIndex + 1) % images.length) {
            className += ' next';
          } else if (index === (currentIndex - 1 + images.length) % images.length) {
            className += ' prev';
          } else if (index === (currentIndex + 2) % images.length) {
            className += ' next-hidden';
          } else if (index === (currentIndex - 2 + images.length) % images.length) {
            className += ' prev-hidden';
          } else {
            className += ' behind';
          }
          return (
            <div
              key={index}
              className={className}
              style={{ backgroundImage: `url(${image})` }}
            />
          );
        })}
      </div>
      <div className='portfolio-controls'>
        <button className="portfolio-nav-button portfolio-prev-button" onClick={handlePrev}>❮</button>
        <button className="portfolio-play-pause-button" onClick={togglePlayPause}>
          {isPlaying ? '❚❚' : '▶'}
        </button>
        <button className="portfolio-nav-button portfolio-next-button" onClick={handleNext}>❯</button>

      </div>
    </div>
  );
};

export default Portfolio;